<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { vodafoneLabNewsletterMixin } from "../../modules/vodafone_lab_mixins_module.js";

export default {
  mixins: [fandomBasicMixin, vodafoneLabNewsletterMixin]
};
</script>

<template>
  <form class="d-flex flex-column" @submit.prevent="submitSimpleForm($event)">
    <div class="form-group mb-3" v-if="areaDropdown">
      <select class="custom-select border-gray-900" v-model="form.data.area">
        <option value="" disabled hidden selected>{{areaDropdown.placeholder}}</option>
        <option v-for="(option, optionIndex) in areaDropdown.options" :key="`option-${optionIndex}`" :value="option.value">{{option.label}}</option>
      </select>
    </div>
    <div class="input-group mb-3" v-if="getFormField('email') && getFormField('email').type !== 'hidden'">
      <input :disabled="!form.data.area" :class="{'disabled': !form.data.area}" type="email" class="form-control border-gray-900" v-model="form.data.email" :placeholder="getFormField('email').placeholder">
      <div class="input-group-append">
        <button class="btn btn-gray-900" :class="{'disabled': !form.data.area}" :disabled="!form.data.area">
          <i class="far fa-chevron-right"></i>
        </button>
      </div>
    </div>
    <div class="form-group form-check d-flex align-items-md-center" v-if="getFormField('newsletter') && getFormField('newsletter').type !== 'hidden'">
      <input type="checkbox" class="form-check-input mt-1 mt-md-0" v-model="form.data.newsletter">
      <label class="form-check-label small text-left" v-html="getFormField('newsletter').label"></label>
    </div>
    <form-feedback :errors="form.errors" :success="form.success" :success-message="content.feedback" class="mb-3 w-100"></form-feedback>
  </form>
</template>

<style lang="scss" scoped>
::v-deep {
  .text-success,
  .text-danger {
    background-color: $white;
    padding: 1rem;

    ul {
      margin: 0;
    }
  }
  .form-check-label p {
    margin-bottom: 0 !important;
  }
}

</style>
